import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import apiUrl from '../../Config'
import { Box, Button, CircularProgress, Divider, Grid, Paper, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tabs, Typography } from '@mui/material'
import { ArrowLeft } from 'lucide-react'

const ViewUserDetails = () => {
    const navigate = useNavigate()

    const location = useLocation()
    const userId = location?.state
    const [loading, setLoading] = useState(false)
    const [tabIndex, setTabIndex] = useState(0);
    const [userBookings, setUserBookings] = useState([]);
    const [bookingsLoading, setBookingsLoading] = useState(false);
    const [bookingsError, setBookingsError] = useState('');
    const [bookingsPage, setBookingsPage] = useState(1);
    const [bookingsLimit, setBookingsLimit] = useState(10);

    const handleTabChange = (event, newValue) => {
        setTabIndex(newValue);
    };
    const [userDetails, setUserDetails] = useState([])
    const [error, setError] = useState('')

    const getUserById = async () => {
        setLoading(true)
        try {
            const res = await axios.get(`${apiUrl}/user/user/${userId}`)
            if (res?.data?.status === true) {
                setUserDetails(res?.data?.user)
            }
        } catch (error) {
            setError(error?.res?.data?.message || "Somthing went to be wrong, try again.")
        }
        finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        getUserById()
    }, [userId])

    useEffect(() => {
        if (tabIndex === 2 && userId) {
            const fetchBookings = async () => {
                setBookingsLoading(true);
                try {
                    const res = await axios.get(
                        `${apiUrl}/bookings/userbookings/${userId}?pageNumber=${bookingsPage}&pageSize=${bookingsLimit}`
                    );
                    if (res?.data?.status === true) {
                        setUserBookings(res.data.bookings || []);
                    } else {
                        setUserBookings([]);
                    }
                } catch (error) {
                    setBookingsError("Failed to fetch bookings.");
                    setUserBookings([]);
                } finally {
                    setBookingsLoading(false);
                }
            };
            fetchBookings();
        }
    }, [tabIndex, userId, bookingsPage, bookingsLimit]);

    if (!userDetails) {
        return (
            <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" height="100%">
                <CircularProgress />
                <Typography mt={2}>Loading users data...</Typography>
            </Box>
        );
    }

    const { name, email, phone, referralCode, referredBy, wallet, vehicles, bookings } = userDetails

    return (
        <>
            <Box sx={{ p: { xs: 2, sm: 4 } }}>
                {/* Header */}
                <Box sx={{ position: 'relative', display: 'flex', alignItems: 'center', mb: 4 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', cursor: "pointer" }} onClick={() => navigate(-1)}>
                        <ArrowLeft size={18} color="#333" />
                        <Typography variant="h6" sx={{ ml: 1, color: "#333" }}>
                            Back
                        </Typography>
                    </Box>
                    <Typography variant="h4" sx={{ position: 'absolute', left: '50%', transform: 'translateX(-50%)', color: "#333" }}>
                        User Details
                    </Typography>
                </Box>

                <Tabs value={tabIndex} onChange={handleTabChange} variant="scrollable" scrollButtons="auto" sx={{ mb: 3 }}>
                    <Tab label="Profile" />
                    <Tab label="Vehicles" />
                    <Tab label="Bookings" />
                </Tabs>

                <Grid container spacing={3}>
                    {/* Profile Avatar */}


                    {/* Personal Information */}
                    {tabIndex === 0 && (
                        <Grid item size={{ xs: 12, sm: 12, md: 12 }}>
                            <Typography variant="h6">Personal Information</Typography>
                            <Divider sx={{ mb: 1 }} />
                            <Grid container spacing={2}>

                                <Grid item size={{ xs: 12, sm: 4 }}><Typography><b>Name:</b> {name}</Typography></Grid>
                                <Grid item size={{ xs: 12, sm: 4 }}><Typography><b>Email:</b> {email}</Typography></Grid>
                                <Grid item size={{ xs: 12, sm: 4 }}><Typography><b>Phone:</b> {phone}</Typography></Grid>
                                <Grid item size={{ xs: 12, sm: 4 }}><Typography><b>Referral Code:</b> {referralCode}</Typography></Grid>
                                <Grid item size={{ xs: 12, sm: 4 }}><Typography><b>Referred By:</b> {referredBy}</Typography></Grid>
                            </Grid>
                        </Grid>)}

                    {/* Vehicle Information */}
                    {tabIndex === 1 && (
                        <Grid item xs={12}>
                            <Typography variant="h6">Vehicle Information</Typography>
                            <Divider sx={{ mb: 1 }} />
                            {vehicles?.length > 0 ? (
                                <Grid container spacing={2}>
                                    {vehicles.map((vehicle, idx) => (
                                        <Grid item xs={12} sm={6} md={4} key={vehicle.id || idx}>
                                            <Box sx={{ border: "2px solid #eee", borderRadius: 2, p: 2, mb: 2 }}>
                                                <Box display="flex" alignItems="center" mb={2}>
                                                    <b>Brand Logo:</b>
                                                    {vehicle?.vehicleBrand?.brandLogo ? (
                                                        <img
                                                            src={vehicle.vehicleBrand.brandLogo}
                                                            alt={vehicle.vehicleBrand.brandName}
                                                            style={{ width: 100, height: 100, marginLeft: 8, borderRadius: 4 }}
                                                        />
                                                    ) : (
                                                        <span style={{ marginLeft: 8 }}>N/A</span>
                                                    )}
                                                </Box>
                                                <Typography variant="subtitle1">
                                                    <strong>Brand Name:</strong> {vehicle?.vehicleBrand?.brandName || "N/A"}
                                                </Typography>
                                                <Typography variant="subtitle1">
                                                    <strong>Model Name:</strong> {vehicle?.brandModel?.modelName || "N/A"}
                                                </Typography>
                                                <Typography variant="subtitle1">
                                                    <strong>Next Service:</strong> {vehicle?.nextService || "N/A"}
                                                </Typography>
                                            </Box>
                                        </Grid>
                                    ))}
                                </Grid>
                            ) : (
                                <Typography display="flex" justifyContent="center" alignItems="center" width={'100%'}>
                                    <Typography>No vehicles found</Typography>
                                </Typography>
                            )}
                        </Grid>
                    )}

                    {/* Booking Details */}
                    {tabIndex === 2 && (
                        <>
                            {/* <Typography variant="h6">Bookings Details</Typography>
                            <Divider sx={{ mb: 1 }} /> */}
                            {bookingsLoading ? (
                                <Typography display="flex" justifyContent="center" alignItems="center" width="100%">
                                    <CircularProgress />
                                </Typography>
                            ) : userBookings.length > 0 ? (
                                <TableContainer component={Paper} sx={{ width: '100%', overflowX: 'auto' }}>
                                    <Table sx={{ minWidth: 650 }}>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell sx={{ fontSize: "0.9rem" }}><strong>Booking Date</strong></TableCell>
                                                <TableCell sx={{ fontSize: "0.9rem" }}><strong>Total Price</strong></TableCell>
                                                <TableCell sx={{ fontSize: "0.9rem" }}><strong>Payment Method</strong></TableCell>
                                                <TableCell sx={{ fontSize: "0.9rem" }}><strong>Payment Status</strong></TableCell>
                                                <TableCell sx={{ fontSize: "0.9rem" }}><strong>Booking Type</strong></TableCell>
                                                <TableCell sx={{ fontSize: "0.9rem" }}><strong>Wallet Used</strong></TableCell>
                                                <TableCell sx={{ fontSize: "0.9rem" }}><strong>Delivery Fee</strong></TableCell>
                                                <TableCell sx={{ fontSize: "0.9rem" }}><strong>Status</strong></TableCell>
                                                <TableCell sx={{ fontSize: "0.9rem" }}><strong>Actions</strong></TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {userBookings.map((booking, idx) => (
                                                <TableRow key={booking.id || idx}>
                                                    <TableCell sx={{ fontSize: "0.9rem" }}>{booking.bookingDate}</TableCell>
                                                    <TableCell sx={{ fontSize: "0.9rem" }}>₹{booking.totalPrice}</TableCell>
                                                    <TableCell sx={{ fontSize: "0.9rem" }}>{booking.paymentMethod}</TableCell>
                                                    <TableCell sx={{ fontSize: "0.9rem" }}>{booking.paymentStatus}</TableCell>
                                                    <TableCell sx={{ fontSize: "0.9rem" }}>{booking.bookingType}</TableCell>
                                                    <TableCell sx={{ fontSize: "0.9rem" }}>₹{booking.walletAmountUsed}</TableCell>
                                                    <TableCell sx={{ fontSize: "0.9rem" }}>₹{booking.deliveryFee}</TableCell>
                                                    <TableCell sx={{ fontSize: "0.9rem" }}>{booking.status}</TableCell>
                                                    <TableCell sx={{ fontSize: "0.9rem" }}>
                                                        <Button
                                                            size="small"
                                                            variant="outlined"
                                                            onClick={() =>
                                                                navigate(`/booking-details/${booking.id}`)
                                                            }
                                                            sx={{ ml: 1 }}
                                                        >
                                                            View More
                                                        </Button>
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            ) : (
                                <Typography display="flex" justifyContent="center" alignItems="center" width={'100%'}>
                                    <Typography>No bookings found</Typography>
                                </Typography>
                            )}
                        </>
                    )}
                </Grid>
            </Box>

        </>
    )
}

export default ViewUserDetails
